import { render, staticRenderFns } from "./VesselsCertificatesIndex.vue?vue&type=template&id=4a9d997a&"
import script from "./VesselsCertificatesIndex.vue?vue&type=script&lang=js&"
export * from "./VesselsCertificatesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports